import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {AccountService} from "./Service";
import Select from "react-select";
import {UploadService} from "../../utils/UploadService";
import {SettingService} from "../setting/Service";

const AddExpense = () => {
    const service = new AccountService();
    const settingService = new SettingService();
    const uploadService = new UploadService();
    const [expenseId, setExpenseId] = useState("");
    const [amount, setAmount] = useState(0);
    const [name, setName] = useState("");
    const [attachement, setAttachement] = useState<File | null>(null);
    const [type, setType] = useState<{ label: string; value: string } | null>(
        null
    );
    const [paymentMode, setPaymentMode] = useState<{
        label: string;
        value: string;
    } | null>(null);
    const [paymentStatus, setPaymentStatus] = useState<{
        label: string;
        value: string;
    } | null>(null);
    const [expenseDate, setExpenseDate] = useState<string | undefined>(undefined);
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [modeOfPayment, setModeOfPayment] = useState("");
    const [notes, setNotes] = useState("");
    const [categoryOptions, setCategoryOptions] = useState<
        { label: string; value: string }[]
    >([]);
    const [category, setCategory] = useState<{ label: string; value: string } | null>(null);

    const [typeOptions, setTypeOptions] = useState<
        { label: string; value: string }[]
    >([
        {label: "Customer", value: "Customer"},
        {label: "Vendor", value: "Vendor"},
        {label: "Staff", value: "Staff"},
    ]);
    const [paymentModeOptions, setPaymentModeOptions] = useState<
        { label: string; value: string }[]
    >([
        {label: "Cash", value: "Cash"},
        {label: "Credit", value: "Credit"},
        {label: "Bank", value: "Bank"},
    ]);
    const [paymentStatusOptions, setPaymentStatusOptions] = useState<
        { label: string; value: string }[]
    >([
        {label: "Pending", value: "Pending"},
        {label: "Paid", value: "Paid"},
        {label: "Cancelled", value: "Cancelled"},
    ]);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (name === "") {
            toast.error("Please fill all the required fields");
            return;
        }
        toast.loading("Adding expense...");
        const attachementUrl = attachement ? await uploadImage(attachement) : null;
        const data = {
            expenseId,
            amount,
            name,
            attachement: attachementUrl,
            type: type?.value,
            paymentMode: paymentMode?.value,
            paymentStatus: paymentStatus?.value,
            expenseDate: expenseDate,
            category: category?.value,
            paymentAmount,
            modeOfPayment,
            notes,
        };
        const res = await service.addExpense(data);
        if (res) {
            toast.success("Expense added successfully");
            setName("");
            setExpenseId("");
            setAmount(0);
            setAttachement(null);
            setType(null);
            setPaymentMode(null);
            setPaymentStatus(null);
            setExpenseDate(undefined);
            setPaymentAmount(0);
            setModeOfPayment("");
            setNotes("");
        }
    };

    const uploadImage = async (file: any) => {
        const res = await uploadService.upload(file);
        return res.length > 0 ? res[0] : null;
    };

    // Set purchase date to current date
    useEffect(() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        setExpenseDate(`${year}-${month}-${day}`);
    }, [])

    useEffect(() => {
        (async () => {
            const res = await settingService.allExpenseCategories();
            if (res) {
                const options = res.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                }));
                setCategoryOptions(options);
            }
        })();
    }, []);

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Expense</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Expense Id <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Expense ID"
                                    value={expenseId}
                                    onChange={(e) => setExpenseId(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Amount <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Amount"
                                    value={amount}
                                    onChange={(e) => setAmount(parseFloat(e.target.value))}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Expense Category <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="expense-type"
                                    options={categoryOptions}
                                    value={category}
                                    onChange={setCategory}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Expense Type <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="expense-type"
                                    options={typeOptions}
                                    value={type}
                                    onChange={setType}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Expense Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Enter Expense Date"
                                    value={expenseDate}
                                    onChange={(e) => setExpenseDate(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Payment Mode <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="payment-mode"
                                    options={paymentModeOptions}
                                    value={paymentMode}
                                    onChange={setPaymentMode}
                                    required={true}
                                />
                            </div>
                        </div>
                        {paymentMode?.value === "Credit" && (
                            <>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-block mb-3">
                                        <label>Payment Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Payment Amount"
                                            value={paymentAmount}
                                            onChange={(e) =>
                                                setPaymentAmount(parseFloat(e.target.value))
                                            }
                                            required={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="input-block mb-3">
                                        <label>Mode of Payment</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter mode of payment"
                                            value={modeOfPayment}
                                            onChange={(e) => setModeOfPayment(e.target.value)}
                                            required={false}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>
                                    Payment Status <span className="text-danger">*</span>
                                </label>
                                <Select
                                    name="payment-status"
                                    options={paymentStatusOptions}
                                    value={paymentStatus}
                                    onChange={setPaymentStatus}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="input-block mb-3">
                                <label>Attachment</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    placeholder="Enter attachment"
                                    onChange={(e) => {
                                        if (e.target.files) {
                                            setAttachement(e.target.files[0]);
                                        }
                                    }}
                                    required={false}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-block mb-3">
                                <label>Notes</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter notes"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    required={false}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Cancel
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AddExpense;
